var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "makeLocationImage" }, [
    _c(
      "div",
      {
        style: {
          height: _vm.windowHeight + "px",
          width: _vm.windowWidth + "px"
        },
        attrs: { id: "make_container" }
      },
      [
        _vm.type === "板块规划"
          ? _c("el-amap-search-box", {
              staticClass: "map-search-box",
              attrs: {
                "search-option": _vm.searchOption,
                "on-search-result": _vm.onSearchResult
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "el-amap",
          {
            ref: "make_map",
            staticClass: "amap-box",
            attrs: {
              vid: "make_map",
              zoom: _vm.zoom,
              center: _vm.center,
              "amap-manager": _vm.amapManager,
              events: _vm.events
            }
          },
          [
            _vm.markers.length > 0
              ? _c("el-amap-marker", {
                  attrs: { vid: "real_search_marker", position: _vm.markers }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.realMarkers, function(value, key) {
              return _c("el-amap-polyline", {
                key: "polyline" + key,
                attrs: {
                  editable: "false",
                  path: value.line,
                  strokeColor: "#F84F39",
                  strokeWeight: "3",
                  strokeStyle: "dashed"
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.realMarkers, function(value, key) {
              return _c("el-amap-marker", {
                key: "newRealMarker" + key,
                attrs: {
                  vid: "newRealMarker" + key,
                  position: value.marker,
                  icon: "./../../static/images/marker7.png",
                  offset: [-16, -25]
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.landMarkers, function(value, key) {
              return _c("el-amap-polyline", {
                key: "polyline" + key,
                attrs: {
                  editable: "false",
                  path: value.line,
                  strokeColor: "red",
                  strokeWeight: "2"
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.landMarkers, function(value, key) {
              return _c("el-amap-marker", {
                key: "landMarker" + key,
                attrs: {
                  vid: "newRealMarker" + key,
                  position: value.marker,
                  icon: "./../../static/images/marker.png",
                  offset: [-16, -25]
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.schoolMarkers, function(value, key) {
              return _c("el-amap-polyline", {
                key: "polyline" + key,
                attrs: {
                  editable: "false",
                  path: value.line,
                  strokeColor: "red",
                  strokeWeight: "2"
                }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.schoolMarkers, function(value, key) {
              return _c("el-amap-marker", {
                key: "schoolMarkers" + key,
                attrs: {
                  vid: "newRealMarker" + key,
                  position: value.marker,
                  icon: "./../../static/images/marker.png",
                  offset: [-16, -25]
                }
              })
            })
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.type === "板块规划"
      ? _c(
          "div",
          { staticClass: "color-note" },
          _vm._l(_vm.colorMap, function(val, key) {
            return _c("div", { key: key, style: { "background-color": val } }, [
              _vm._v("\n      " + _vm._s(key) + "\n    ")
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "板块热力"
      ? _c(
          "div",
          { staticClass: "color-note" },
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "请选择热力图" },
                on: { change: _vm.drawHeatMap },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              },
              _vm._l(_vm.options, function(item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value }
                })
              }),
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "板块配套"
      ? _c(
          "div",
          { staticClass: "color-right" },
          [
            _c("div", [_vm._v("图例")]),
            _vm._v(" "),
            _vm._l(_vm.colorPtMap, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "color-item",
                  on: {
                    click: function($event) {
                      return _vm.changeColor(item.txt)
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "color-circle",
                    style: { "background-color": item.color }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.txt))])
                ]
              )
            }),
            _vm._v(" "),
            _vm.type === "板块配套" && _vm.pttype !== "全部"
              ? _c(
                  "div",
                  {
                    staticClass: "color-right-btn",
                    on: {
                      click: function($event) {
                        return _vm.changeColor("全部")
                      }
                    }
                  },
                  [_vm._v("\n      清除筛选\n    ")]
                )
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "板块规控及重要规划"
      ? _c(
          "div",
          {
            staticClass: "color-right",
            staticStyle: { "align-items": "flex-start" }
          },
          [
            _c("div", { staticStyle: { "margin-left": "20px" } }, [
              _vm._v("图例")
            ]),
            _vm._v(" "),
            _vm._l(_vm.colorKgMap, function(item, index) {
              return _c("div", { key: index, staticClass: "color-item" }, [
                _c("div", {
                  staticClass: "color-cell",
                  style: { "background-color": item.color }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.txt) + "用地")])
              ])
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "margin-top": "20px" },
                attrs: { type: "primary" },
                on: { click: _vm.drawPoster }
              },
              [_vm._v("生成海报")]
            )
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "板块新盘分布"
      ? _c(
          "div",
          {
            staticClass: "color-right",
            staticStyle: { "align-items": "flex-start" }
          },
          [
            _c("div", { staticStyle: { "margin-left": "20px" } }, [
              _vm._v("图例")
            ]),
            _vm._v(" "),
            _vm._l(_vm.colorNEMap, function(item, index) {
              return _c("div", { key: index, staticClass: "color-item" }, [
                _c("div", {
                  staticClass: "color-circle",
                  style: { "background-color": item.color }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.txt))])
              ])
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "控规"
      ? _c(
          "div",
          { staticClass: "choose-area" },
          [
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  placeholder: "选择板块",
                  "default-first-option": "",
                  multiple: ""
                },
                model: {
                  value: _vm.areaIdList,
                  callback: function($$v) {
                    _vm.areaIdList = $$v
                  },
                  expression: "areaIdList"
                }
              },
              _vm._l(_vm.areaList, function(group) {
                return _c(
                  "el-option-group",
                  { key: group.label, attrs: { label: group.label } },
                  _vm._l(group.options, function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.area_name, value: item.id }
                    })
                  }),
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.drawAreaPlanImage }
              },
              [_vm._v("查控规图")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.drawAreaPlanCell }
              },
              [_vm._v("已画地块")]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentArea === "全城" &&
    ["新房", "待首开", "公示登记", "土拍"].includes(_vm.type) &&
    _vm.sizeLevel < 3
      ? _c(
          "div",
          {
            staticClass: "color-note",
            staticStyle: { "background-color": "#ff0000" },
            on: { click: _vm.changeSize }
          },
          [_c("div", [_vm._v(_vm._s(_vm.sizeLevel))])]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "地铁图"
      ? _c(
          "div",
          {
            staticClass: "color-note",
            staticStyle: { "background-color": "#ffffff" }
          },
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "请选择地铁线路" },
                on: { change: _vm.drawOneSubway },
                model: {
                  value: _vm.curline,
                  callback: function($$v) {
                    _vm.curline = $$v
                  },
                  expression: "curline"
                }
              },
              _vm._l(_vm.sublines, function(item) {
                return _c("el-option", {
                  key: item,
                  attrs: { label: item, value: item }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "当前：宽" +
                  _vm._s(_vm.windowWidth) +
                  "，高" +
                  _vm._s(_vm.windowHeight)
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n      宽度:\n      "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.widthSet,
                    expression: "widthSet"
                  }
                ],
                staticStyle: { width: "50px" },
                attrs: { type: "number" },
                domProps: { value: _vm.widthSet },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.widthSet = $event.target.value
                  }
                }
              }),
              _vm._v(" 高度:\n      "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.heightSet,
                    expression: "heightSet"
                  }
                ],
                staticStyle: { width: "50px" },
                attrs: { type: "number" },
                domProps: { value: _vm.heightSet },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.heightSet = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("button", { on: { click: _vm.resetWindow } }, [_vm._v("重置")])
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("canvas", {
      ref: "canvasPoster",
      staticStyle: { position: "absolute", left: "-100%" }
    }),
    _vm._v(" "),
    _vm.mpCode
      ? _c("div", { staticClass: "image-background2" }, [
          _c(
            "div",
            { staticClass: "image-preview2" },
            [
              _c(
                "span",
                {
                  staticClass: "close2",
                  on: {
                    click: function($event) {
                      _vm.mpCode = null
                    }
                  }
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c("el-image", {
                staticStyle: { height: "400px", width: "600px" },
                attrs: { src: _vm.mpCode, "preview-src-list": [_vm.mpCode] }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfca9698", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfca9698","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/makeLocationImage/index.vue
// module id = null
// module chunks = 